/**
 * @Author: 韩祺涛
 * @Date: 2022-12-01
 * @Project: 杭氧客户现场使用
 */
export default {
  state: {
    subcompanyid: {},
    // 设备参数管理页面的左侧树至表格传参使用
    searchId: {}
  },
  getters: {
    subcompanyid: state => state.subcompanyid,
    searchId: state => state.searchId
  },
  mutations: {
    subcompanyid: (state, data) => {
      state.subcompanyid = data
    },
    searchId: (state, data) => {
      state.searchId = data
    }
  },
  actions: {
    // 气体设备台账页面左上树至表格传参使用
    handleSubcompanyid (subcompanyid, data) {
      subcompanyid.commit('subcompanyid', data)
    },
    // 气体设备台账页面左下树至表格传参使用
    handleSearchId (searchId, data) {
      searchId.commit('searchId', data)
    }
  }
}
